import { useCallback, useState } from 'react';
import { resolveAndroidApkDownload } from '../services/mobile/androidApkDownload';

export function useAndroidApkDownload() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);

  const download = useCallback(async () => {
    setBusy(true);
    setError(false);
    try {
      const release = await resolveAndroidApkDownload();
      if (!release) {
        setError(true);
        return false;
      }
      const anchor = document.createElement('a');
      anchor.href = release.url;
      anchor.download = release.fileName;
      anchor.rel = 'noopener noreferrer';
      anchor.target = '_blank';
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      return true;
    } catch {
      setError(true);
      return false;
    } finally {
      setBusy(false);
    }
  }, []);

  return { busy, error, download };
}
